/**
 * /dashboard/offboarding/new — New offboarding cycle
 * (G4.6 — POST /api/v1/offboarding/cycles).
 *
 * HR-admin only — both at the gate here and at the backend.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/offboarding/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { HrModuleShell } from "@/components/shared/hr-module-shell";
import { OffboardingRoleGate } from "@/components/offboarding/offboarding-role-gate";
import { CycleForm } from "@/components/offboarding/cycle-form";
import { Card, CardContent } from "@/components/ui/card";

// ?employee_id= pre-selects the person — the employee page's "Start
// offboarding" action links here (2026-10 people wave).
const newCycleSearchSchema = z.object({
  employee_id: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hr/offboarding/new")({
  validateSearch: newCycleSearchSchema,
  component: NewOffboardingCycleRoute,
});

function NewOffboardingCycleRoute() {
  const { employee_id: preselectEmployeeId } = Route.useSearch();
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <HrModuleShell
      title="New Offboarding Cycle"
      description="Record that someone is leaving. The standard exit checklist is added for you."
    >
      <OffboardingRoleGate>
        <Card className="max-w-2xl">
          <CardContent className="pt-6">
            <CycleForm preselectEmployeeId={preselectEmployeeId} />
          </CardContent>
        </Card>
      </OffboardingRoleGate>
    </HrModuleShell>
  );
}
